import {
  dispatchDataLayerEventOnClick,
  dispatchDataLayerEventOnProductsClickGA4,
  dispatchDataLayerHomepageProductImpressionsGA,
} from '../../../../helpers/dataLayerHelpers/HomepageDataLayerHelper';
import { IImpressions } from '../../../../types/product/productDetailPage';
import { ProductListOnClick } from '../types';

const HOMEPAGE_POPULARPRODUCTS = 'homepage_popularproducts';

export const handlePopularProductOnClick: ProductListOnClick = (position, productName) => {
  const eventPayload = {
    item: HOMEPAGE_POPULARPRODUCTS,
    position,
  };

  const eventdata = {
    eventName: HOMEPAGE_POPULARPRODUCTS,
    position,
    productName,
  };

  dispatchDataLayerEventOnClick(eventPayload);
  dispatchDataLayerEventOnProductsClickGA4(eventdata);
};

export const observerCallbackOnPopularProducts = (dataAttribute: IImpressions) => {
  dispatchDataLayerHomepageProductImpressionsGA(dataAttribute?.products, HOMEPAGE_POPULARPRODUCTS);
};
